import React from "react";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";

export default function Seo({
  slug,
  type = "article",
  title,
  description,
  cover,
}) {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
          facebookAppId
        }
      }
      file(relativePath: { eq: "lostwithlydia-01.png" }) {
        publicURL
      }
    }
  `);

  const sameAs = [
    "https://www.instagram.com/lostwithlydia",
    "https://www.pinterest.com/lostwithlydia/",
    "https://www.facebook.com/lostwithlydia/",
    "https://www.tiktok.com/@lostwithlydia",
  ];

  const ld = {
    "@context": "https://schema.org/",
    "@type": type === "article" ? "BlogPosting" : undefined,
    name: title,
    headline: title,
    description: description,
    url: data.site.siteMetadata.siteUrl + slug,
    logo: data.site.siteMetadata.siteUrl + data.file.publicURL,
    image: cover?.publicURL ? [cover.publicURL] : undefined,
    inLanguage: "en-US",
    isFamilyFriendly: "true",
    author: {
      "@type": "Person",
      name: "Lydia",
      url: data.site.siteMetadata.siteUrl + "/about/",
      sameAs,
    },
    publisher: {
      "@type": "Organization",
      name: "Lost With Lydia",
      logo: data.site.siteMetadata.siteUrl + data.file.publicURL,
      sameAs,
    },
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate:
          data.site.siteMetadata.siteUrl +
          "/destinations/?q={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <Helmet
      htmlAttributes={{
        lang: "en",
      }}
    >
      {title && <title>{title}</title>}
      {title && <meta property="og:title" content={title} />}
      {description && <meta name="description" content={description} />}
      {description && <meta property="og:description" content={description} />}
      {slug && (
        <meta
          property="og:url"
          content={data.site.siteMetadata.siteUrl + slug}
        />
      )}
      {type && <meta property="og:type" content={type} />}
      {cover && (
        <meta
          property="og:image"
          content={data.site.siteMetadata.siteUrl + cover.publicURL}
        />
      )}
      <meta
        property="fb:app_id"
        content={data.site.siteMetadata.facebookAppId}
      />
      <meta property="og:site_name" content="Lost with Lydia" />
      <meta name="ir-site-verification-token" value="1632546885" />

      <script type="application/ld+json">{JSON.stringify(ld)}</script>
    </Helmet>
  );
}
